import React, { Component } from 'react';

export default class ArenaHeader extends Component {
  render() {
    const { arenaName, address, showIntro = true } = this.props;
    return (
      <>
        <section className="arena-header">
          <div style={{display: 'flex', alignItems: 'center', gap: 10}}>
          {arenaName && <span className="arena-header__icon" aria-hidden="true">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
              <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
              <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
              <path d="M10 6h4" />
              <path d="M10 10h4" />
              <path d="M10 14h4" />
              <path d="M10 18h4" />
            </svg>
          </span>}
          <p className="arena-header__subtitle">
            {arenaName ? arenaName : ''}
          </p>
          </div>
          <div>
          <p className="arena-header__subtitle address">
            {address ? address : ''}
          </p>
          </div>
        </section>
        {showIntro && (
          <div className="arena-intro">
            <h1 className="arena-intro__title">Choose Your Parking Plan</h1>
            <p className="arena-intro__description">
              Select the monthly plan that works best for you
            </p>
          </div>
        )}
      </>
    );
  }
}

